import React from 'react';
import { observer } from 'mobx-react';
import { Flex } from 'antd';
import { translator } from 'core/localization';
import { useStore } from 'core/react/useStore';
import { AntSwitch } from 'controls/react/ant/antSwitch';
import { HelpIcon } from 'controls/react/form/formEntryNew';
import { ActionTriggerSwitcherStore } from './actionTriggerSwitcherStore';
import { ActionTriggerSwitcherProps } from './types';

const i = translator({
	'This toggle sets the actiontrigger for this user or team active or inactive': {
		no: 'Denne vekselen setter handlingsutløser for denne brukeren eller teamet aktivt eller inaktivt',
	},
	'Actiontrigger can only be enabled after user is created': {
		no: 'Handlingsutløser kan aktiviseres etter at bruker er opprettet',
	},
	'Actiontrigger': { no: 'Handlingsutløser' },
});

export const ActionTriggerSwitcher = observer((props: ActionTriggerSwitcherProps) => {
	const store = useStore(() => new ActionTriggerSwitcherStore(), { props });

	const tooltip = props.id
		? i('This toggle sets the actiontrigger for this user or team active or inactive')
		: i('Actiontrigger can only be enabled after user is created');

	return (
		<Flex align="center" justify="flex-start" gap={20}>
			<span>
				{i('Actiontrigger')}&nbsp;
				<HelpIcon tooltip={tooltip} />
			</span>
			<AntSwitch
				value={store.isEnabled}
				onChange={(value: boolean) => store.setEnabled(value)}
				disabled={!store.loaded || props.disabled}
			/>
		</Flex>
	);
});
